import * as React from 'react';
import { Theme } from '@mui/material/styles';
import { withStyles } from 'tss-react/mui';
import classNames from 'classnames';
import { EDCard } from '../../../../BaseComponents/Card/EDCard';
import { EDCardContent } from '../../../../BaseComponents/Card/EDCardContent';
import EDBox from '../../../../BaseComponents/EDBox/EDBox';

interface IProps {
  type: InfoType;
  classes?: any;
}

export enum InfoType {
  description,
  manual,
  result,
}

const styles = (theme: Theme) => ({
  root: {
    display: 'flex',
    flex: '1 1 auto',
    backgroundColor: theme.customProperties.ActivityCardPanel.rootLightBg,
    width: '100%',
    overflow: 'hidden',
  },
  rootFillHeight: {
    minHeight: '150px',
    height: '100%',
  },
  rootFixedHeight: {
    height: '150px', // TODO: ta bort?
  },
  container: {
    display: 'flex',
    flex: '1 1 auto',
    flexDirection: 'row',
    paddingTop: 0,
    paddingBottom: '0px !important',
    paddingLeft: 0,
  },
  childContainer: {
    marginTop: theme.spacing(2),
    marginLeft: theme.spacing(2),
    maxHeight: '300px',
    overflowY: 'auto',
  },
  sideBar: {
    width: theme.spacing(4),
    paddingTop: 0,
    paddingBottom: 0,
  },
  sideBarManualColor: {
    backgroundColor: theme.customProperties.ProcessColors.activeStepBg,
    color: theme.customProperties.Fade.LightOnDark.highEmphasis,
    font: '300 12px ' + theme.typography.fontFamily,
  },
  sideBarDescriptionColor: {
    backgroundColor: theme.customProperties.ProcessColors.passiveStepBg,
    color: theme.customProperties.Fade.DarkOnLight.lowEmphasis,
    font: '500 12px ' + theme.typography.fontFamily,
  },
  sideBarResultColor: {
    backgroundColor: theme.customProperties.ProcessColors.passiveStepBg,
    color: theme.customProperties.Fade.DarkOnLight.lowEmphasis,
    font: '500 12px ' + theme.typography.fontFamily,
  },
});

/**
 * Komponent som visar information i en ProcessAktivitet
 */
export const ActivityCard: React.FunctionComponent<
  React.PropsWithChildren<IProps>
> = props => {
  const { classes } = props;

  let sideBarColorClass = classes.sideBarDescriptionColor;
  let sideBarInfoText = 'Beskrivning';
  switch (props.type) {
    case InfoType.manual:
      sideBarColorClass = classes.sideBarManualColor;
      sideBarInfoText = 'Åtgärd krävs';
      break;
    case InfoType.result:
      sideBarColorClass = classes.sideBarResultColor;
      sideBarInfoText = 'Resultat';
  }

  return (
    <EDCard raised>
      <EDCardContent noPadding>
        <EDBox
          sx={{
            height: '100%',
            display: 'flex',
            flex: '1 1 auto',
            flexDirection: 'row',
            paddingTop: 0,
            paddingBottom: '0px !important',
            paddingLeft: 0,
          }}
        >
          <div className={classNames(classes.sideBar, sideBarColorClass)}>
            <div
              style={{
                transform: 'rotate(90deg) translate(1em, -1.25em)',
                transformOrigin: 'left',
                whiteSpace: 'nowrap',
              }}
            >
              {sideBarInfoText}
            </div>
          </div>
          <div className={classes.childContainer}>{props.children}</div>
        </EDBox>
      </EDCardContent>
    </EDCard>
  );
};

export default withStyles(ActivityCard, styles);
